export const SITE_URL = 'https://pegasusux.net';
export const SITE_NAME = 'Pegasus UX';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': ['ProfessionalService', 'LocalBusiness'],
  '@id': `${SITE_URL}/#organization`,
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  image: DEFAULT_OG_IMAGE,
  description:
    'Pegasus UX is a Dallas, TX-based, remote-first UX design, research, and strategy agency serving enterprise, fintech, AI, developer tooling, logistics, and SaaS companies nationwide.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Dallas',
    addressRegion: 'TX',
    addressCountry: 'US',
  },
  areaServed: ['Dallas, TX', 'Dallas-Fort Worth', 'Texas', 'United States'],
  knowsAbout: [
    'UX Agency Dallas',
    'Dallas UX Design',
    'Dallas Product Design Agency',
    'Enterprise UX Design',
    'FinTech UX Design',
    'AI UX Design',
    'SaaS UX Design',
    'Logistics UX Design',
    'Web App UX Design',
    'UX Research',
    'UX Strategy',
    'UX Audits',
    'UX Testing',
    'Design Systems',
    'UI/UX Design Consulting',
  ],
  makesOffer: [
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'UX Design' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'UX Strategy & Design Ops' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'UX Research' } },
    { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'UX Audit' } },
  ],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  publisher: { '@id': `${SITE_URL}/#organization` },
};

export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export function serviceSchema({ name, description, path }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    provider: { '@id': `${SITE_URL}/#organization` },
    areaServed: 'Worldwide',
    url: `${SITE_URL}${path}`,
  };
}

export function articleSchema({ title, description, path, datePublished, dateModified }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    description,
    url: `${SITE_URL}${path}`,
    datePublished,
    dateModified: dateModified || datePublished,
    author: { '@id': `${SITE_URL}/#organization` },
    publisher: { '@id': `${SITE_URL}/#organization` },
    mainEntityOfPage: `${SITE_URL}${path}`,
  };
}

export function faqSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}
